import React from 'react'
import { Badge } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'

type Props = {
  className?: string
}
/**
 * Tag a sale line item as a special order product
 */
export const SpecialOrderProductTag = (props: Props) => {
  const t = useT()
  return (
    <div className={`uc-base ${props.className ?? ''}`}>
      <Badge
        appearance="default"
        size="medium"
        customDataAttributes={{
          container: { 'data-testid': 'special-order-product-tag' },
        }}
      >
        {t('SPECIAL ORDER PRODUCT', {
          _context: 'Tagging a product as a special order product',
        })}
      </Badge>
    </div>
  )
}
